module.exports = __webpack_public_path__ + "static/media/LS027B7DH01 Spec (LD-28305A).02b53ab6.pdf";